import { Label, LabelColor } from '@shared/components';

export default function ExamRoundNumberTag({ roundNumber }: { roundNumber: number }) {
  return (
    <Label
      color={LabelColor.GREY}
      sx={(theme) => ({
        borderRadius: theme.shape.rounded(5),
        p: theme.spacing(0.5, 3),
        fontWeight: 600,
      })}
    >
      ช่วงสอบที่ {roundNumber}
    </Label>
  );
}
